import React from 'react';
import SMMapHelper from 'components/helpers/SMMapHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import sprintf from 'sprintf';

class SMSpaceMapView extends React.Component {
  
  constructor(props) {
    super(props);
  }
  
  componentDidMount() {
    
    const position = new google.maps.LatLng(
      this.props.space.latitude,
      this.props.space.longitude
    );
    const googleMap = SMMapHelper.googleMap(this.refs.mapCanvas, position, 15);
    const marker = new google.maps.Marker({
      position: position,
      draggable: false,
      icon: googleMap.markerImage,
      map: googleMap.map
    });
    const space = this.props.space;
    const googleMapUrl = sprintf("https://www.google.com/maps?q=%s,%s+(%s)",
      space.latitude,
      space.longitude,
      encodeURIComponent(space.name)
    );
    const infowindow = new google.maps.InfoWindow({
      content: sprintf(
        '<div class="js-space__map-pickup search-list__map-picup clearfix">' +
          '<a target="_blank" href="%s"><img src="%s" alt="%s" class="is-hover fl"></a>' +
          '<div class="search-list__map-picup-inner">' +
            '<h2 class="search-list__map-picup-title">%s<br>' +
            '<a target="_blank" href="%s">Google Mapでみる</a>' +
            '</h2>' +
          '</div>' +
        '</div>',
        googleMapUrl, space.cover_photo, space.name, space.name, googleMapUrl
      )
    });
    const hasInfoWindow = this.props.hasInfoWindow;
    marker.addListener('click', function() {
      if (SMAppHelper.isMobile() || !hasInfoWindow) {
        window.open(googleMapUrl);
      } else {
        infowindow.open(googleMap.map, marker);
      }
    });
  }
  
  render() {
    return(
      <div ref="mapCanvas" style={{width: "100%", height:"100%"}}></div>
    );
  }
}
export default SMSpaceMapView;



// WEBPACK FOOTER //
// ./app/javascript/components/spaces/SMSpaceMapView.jsx